import axios from '@/lib/axios';
import { CustomerParams } from '../types';

const confirmCustomer = (data: CustomerParams, custCode: string) => {
  return axios.post(`/facility/facility_agreements/customers/${custCode}/confirm`, data);
}

export default confirmCustomer;